import { NumberField } from "aderant-conflicts-models";
import React from "react";
import { FieldWrapper } from "./FieldWrapper";

interface NumberInformationProps {
    field: NumberField;
}

export const NumberInformation = (props: NumberInformationProps) => {
    const {
        field: { fieldLabel, value }
    } = props;
    
    return (
        <FieldWrapper fieldLabel={fieldLabel}>
            {value}
        </FieldWrapper>
    );
};
